import { render, staticRenderFns } from "./SellCoinsPurchaseHistory.vue?vue&type=template&id=8fe330ac&scoped=true&"
import script from "./SellCoinsPurchaseHistory.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsPurchaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsPurchaseHistory.vue?vue&type=style&index=0&id=8fe330ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe330ac",
  null
  
)

export default component.exports